/*
 * Demo gallery contents.
 *
 * TO ADD A REAL VIDEO — two steps, no code change beyond this file:
 *
 *   1. Drop the files into `frontend/public/media/gallery/`:
 *        my-demo.mp4        the video itself (H.264/AAC plays everywhere)
 *        my-demo.jpg        a poster frame  (see scripts/gallery-poster.sh)
 *        my-demo.vtt        captions        (optional but see `captions` below)
 *
 *   2. Add an entry below with `video: "/media/gallery/my-demo.mp4"`.
 *
 * `video` may also be an absolute URL, so the files can live on S3/MinIO or a
 * CDN instead of in the image — worth doing once they are large, since
 * anything under public/ is baked into the frontend container at build time.
 *
 * An entry with no `video` still renders, as the placeholder card it is today.
 * That is deliberate: the gallery should never show a broken player, and it
 * lets you fill the grid one video at a time.
 */
// Every sample is voiced by DemoCraft (no presenter's own voice) and shows no
// personal names or e-mail addresses: screenshots were OCR-checked and blurred
// before rendering, and the screen recordings had their account and bookmark
// areas blurred. Keep it that way when adding one.
export const GALLERY = [
  {
    id: "nextopp",
    title: "NextOpp",
    format: "3:05 screen recording · AI voice",
    tone: "Energetic",
    video: "/media/gallery/nextopp.mp4",
    poster: "/media/gallery/nextopp.jpg",
    captions: "/media/gallery/nextopp.vtt",
  },
  {
    id: "democraft",
    title: "DemoCraft",
    format: "1:29 product walkthrough",
    tone: "Instructional",
    video: "/media/gallery/democraft.mp4",
    poster: "/media/gallery/democraft.jpg",
    captions: null,
  },
  {
    id: "democraft-telugu",
    title: "DemoCraft in Telugu",
    format: "1:55 Telugu voice + captions",
    tone: "Instructional",
    video: "/media/gallery/democraft-telugu.mp4",
    poster: "/media/gallery/democraft-telugu.jpg",
    captions: null,   // burnt into the picture
  },
  {
    id: "unicraft-ai",
    title: "UniCraft AI",
    format: "2:12 feature tour",
    tone: "Enthusiastic",
    video: "/media/gallery/unicraft-ai.mp4",
    poster: "/media/gallery/unicraft-ai.jpg",
    captions: "/media/gallery/unicraft-ai.vtt",
  },
  {
    id: "govcraft",
    title: "GovCraft",
    format: "0:48 screen recording · AI voice",
    tone: "Instructional",
    video: "/media/gallery/govcraft.mp4",
    poster: "/media/gallery/govcraft.jpg",
    captions: "/media/gallery/govcraft.vtt",
  },
  {
    id: "toolmesh",
    title: "ToolMesh",
    format: "0:51 screen recording · AI voice",
    tone: "Energetic",
    video: "/media/gallery/toolmesh.mp4",
    poster: "/media/gallery/toolmesh.jpg",
    captions: "/media/gallery/toolmesh.vtt",
  },
];

export const hasRealVideos = () => GALLERY.some((d) => Boolean(d.video));
